// extracted by mini-css-extract-plugin
export var footerAreaMobil = "styles-header-footer-module--footerAreaMobil--993ad";
export var footerContainerImage = "styles-header-footer-module--footerContainerImage--87668";
export var footerDivision = "styles-header-footer-module--footerDivision--0a4be";
export var footerOpcionesMovil = "styles-header-footer-module--footerOpcionesMovil--4dd8b";
export var footertextInfo = "styles-header-footer-module--footertextInfo--a5ac5";